import apiUrl from '../../../helpers/apiUrl';
import axios, { AxiosResponse } from 'axios';
import RoutesIndexes from 'modules/authModule/enums/RoutesIndexes';
import { message } from 'antd';
import moment from 'moment';

const getNewsRequest = async (): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/news`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response: AxiosResponse<{ code: number; message: string }>) => {
      if (response?.data) {
        return response.data;
      }
    });
};

const getNewsCategoriesRequest = async (): Promise<{
  code: number;
  message: string;
  error?: number;
  data?: any;
} | void> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/news/categories`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then(
      (
        response:
          | AxiosResponse<{ code: number; message: string }>
          | { data: { code: number; message: string } }
      ) => {
        if (response.data.code === RoutesIndexes.WRONG_USERNAME_OR_PASSWORD) {
          message.error(response.data.message);
        }
        if (response?.data) {
          return response.data;
        }
      }
    )
    .catch((e) => {
      message.error(e.message);
    });
};

const getSpecificNewsRequest = async (id: string): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/news/${id}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      const { data } = response;
      if (data) {
        return data;
      }
    })
    .catch((e) => {
      message.error(e.message);
    });
};

const getSpecificNewsCategoryRequest = async (id: string): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/news/categories/${id}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      const { data } = response;
      if (data) {
        return data;
      }
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

const removeSpecificNewsRequest = async (idNews: number): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .delete(`${apiUrl()}backoffice/news/${idNews}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .catch((e): any => {
      message.error(e.message);
      return false;
    });
};

const removeSpecificNewsCategoryRequest = async (id: number): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .delete(`${apiUrl()}backoffice/news/categories/${id}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then(() => {
      return true;
    })
    .catch((e): any => {
      message.error(e.message);
      return false;
    });
};

const createNewsRequest = async (data: {
  id?: number;
  dateAdd: moment.MomentInput;
  name: string;
  intro: string;
}): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .post(`${apiUrl()}backoffice/news`, data, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response: any) => {
      if (response.data?.error === 'DUPLICATE') {
        message.error('Wpis o danym tytule już istnieje');
      } else {
        message.success('Pozytywnie utworzono newsa');
      }
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

const createNewsCategoryRequest = async (data: {
  isActive?: boolean;
  name: string;
}): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .post(`${apiUrl()}backoffice/news/categories`, data, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then(() => {
      message.success('Pozytywnie utworzono kategorię newsa');
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

const saveNewsRequest = async (data: { id: number }): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .put(
      `${apiUrl()}backoffice/news/${data.id}`,
      {
        data,
      },
      {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(<string>tokenString)?.accessToken
          }`,
        },
      }
    )
    .then(() => {
      message.success('Pozytywnie zapisano');
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

const saveNewsCategoryRequest = async (data: { id: number }): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .put(
      `${apiUrl()}backoffice/news/categories/${data.id}`,
      {
        data,
      },
      {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(<string>tokenString)?.accessToken
          }`,
        },
      }
    )
    .then(() => {
      message.success('Pozytywnie zapisano');
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

export {
  saveNewsRequest,
  getSpecificNewsRequest,
  getNewsRequest,
  removeSpecificNewsRequest,
  createNewsRequest,
  getNewsCategoriesRequest,
  removeSpecificNewsCategoryRequest,
  getSpecificNewsCategoryRequest,
  createNewsCategoryRequest,
  saveNewsCategoryRequest,
};
